// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body_text":"BodyText__body_text--2GH2b"};